export default {
  namespaced: true,
  state: {
    cover: {
      claim: {
        id: '',
        status: '',
        number: '',
        buyerContact: {
          firstName: '',
          lastName: '',
          email: '',
          mobilePhone: '',
          officePhone: ''
        },
        sellerContact: {
          firstName: '',
          lastName: '',
          email: '',
          mobilePhone: '',
          officePhone: ''
        },
        createdAt: '',
        owner: {
          firstName: '',
          lastName: '',
          initials: '',
          calculatedColor: ''
        },
        documents: [],
        claimContextInfo: {
          clientReferenceNumber: '',
          isDisputed: '',
          isInsolvencyProceeding: '',
          comment: '',
          collectedAmount: '',
          amountWithoutVAT: '',
          deliveryDate: ''
        }
      },
      invoice: {
        status: '',
        statusCode: '',
        amount: '',
        currency: '',
        number: '',
        issuedAt: '',
        dueAt: '',
        isTooLate: false,
        isDueDatePassed: false,
        daysLate: '',
        tooLateDescription: '',
        fundedAmount: '',
        fundedAmountValue: '',
        seller: {
          id: '',
          name: '',
          address: {
            country: '',
            city: '',
            streetNumber: '',
            streetName: '',
            postCode: ''
          },
          externalIds: [],
          identifierType: '',
          identifierValue: ''
        },

        buyer: {
          id: '',
          name: '',
          address: {
            country: '',
            city: '',
            streetNumber: '',
            streetName: '',
            postCode: ''
          },
          externalIds: [],
          identifierType: '',
          identifierValue: ''
        }
      },
      details: {
        id: '',
        activatedAt: '',
        quotedAt: '',
        duration: '',
        totalCoverPrice: '',
        originTab: '',
        validUntil: '',
        isRemaining: false,
        daysRemaining: '',
        settledAt: ''
      },
      price: {
        insurancePremium: '',
        totalServiceFee: '',
        serviceFeeAmount: '',
        serviceFeeVatAmount: '',
        serviceFeeRate: '',
        serviceFeeVatRate: '',
        totalCollectionFee: '',
        collectionFeeAmount: '',
        collectionFeeVatAmount: '',
        collectionFeeRate: '',
        collectionFeeVatRate: '',
        insuranceTaxAmount: ''
      }
    },
    extendedMode: true,
    lateHeaders: [
      { text: '', align: 'left', value: 'islate', sortable: false },
      { text: 'Cover.ListCover.SELLER_COLUMN_NAME', align: 'left', value: 'seller', sortable: false },
      { text: 'Cover.ListCover.BUYER_COLUMN_NAME', align: 'left', value: 'buyer', sortable: false },
      { text: 'Cover.ListCover.DUE_DATE_COLUMN_NAME', align: 'left', value: 'duedate', sortable: false },
      { text: 'Cover.ListCover.AMOUNT_COLUMN_NAME', align: 'left', value: 'amount', sortable: false },
      { text: 'Cover.ListCover.INVOICE_NUMBER_COLUMN_NAME', align: 'left', value: 'number', sortable: false },
      { text: 'Cover.ListCover.COVER_PRICE_COLUMN_NAME', align: 'left', value: 'coverprice', sortable: false },
      { text: 'Cover.ListCover.ACTION_COLUMN_NAME', align: 'left', value: 'action', sortable: false }
    ],
    claimedHeaders: [
      { text: '', align: 'left', value: 'first', sortable: false },
      { text: 'Cover.ListCover.SELLER_COLUMN_NAME', align: 'left', value: 'seller', sortable: false },
      { text: 'Cover.ListCover.BUYER_COLUMN_NAME', align: 'left', value: 'buyer', sortable: false },
      { text: 'Cover.ListCover.INVOICE_NUMBER_COLUMN_NAME', align: 'left', value: 'number', sortable: false },
      { text: 'Cover.ListCover.AMOUNT_COLUMN_NAME', align: 'left', value: 'amount', sortable: false },
      { text: 'Cover.ListCover.CLAIMED_AT_COLUMN_NAME', align: 'left', value: 'claimedat', sortable: false },
      { text: 'Cover.ListCover.OWNER_COLUMN_NAME', align: 'left', value: 'claimowner', sortable: false },
      { text: 'Cover.ListCover.CLAIM_REF_COLUMN_NAME', align: 'left', value: 'claimref', sortable: false },
      { text: 'Cover.ListCover.CLAIM_STATUS_COLUMN_NAME', align: 'left', value: 'claimstatus', sortable: false },
      { text: 'Cover.ListCover.ACTION_COLUMN_NAME', align: 'left', value: 'action', sortable: false }
    ],
    archivedHeaders: [
      { text: '', align: 'left', value: 'first', sortable: false },
      { text: 'Cover.ListCover.SELLER_COLUMN_NAME', align: 'left', value: 'seller', sortable: false },
      { text: 'Cover.ListCover.BUYER_COLUMN_NAME', align: 'left', value: 'buyer', sortable: false },
      { text: 'Cover.ListCover.ISSUE_DATE_COLUMN_NAME', align: 'left', value: 'issuedate', sortable: false },
      { text: 'Cover.ListCover.DUE_DATE_COLUMN_NAME', align: 'left', value: 'duedate', sortable: false },
      { text: 'Cover.ListCover.AMOUNT_COLUMN_NAME', align: 'left', value: 'amount', sortable: false },
      { text: 'Cover.ListCover.INVOICE_NUMBER_COLUMN_NAME', align: 'left', value: 'number', sortable: false },
      { text: 'Cover.ListCover.INVOICE_STATUS_COLUMN_NAME', align: 'left', value: 'status', sortable: false },
      { text: 'Cover.ListCover.ACTION_COLUMN_NAME', align: 'left', value: 'action', sortable: false }
    ],
    activatedHeaders: [
      { text: '', align: 'left', value: 'islate', sortable: false },
      { text: 'Cover.ListCover.SELLER_COLUMN_NAME', align: 'left', value: 'seller', sortable: false },
      { text: 'Cover.ListCover.BUYER_COLUMN_NAME', align: 'left', value: 'buyer', sortable: false },
      { text: 'Cover.ListCover.DUE_DATE_COLUMN_NAME', align: 'left', value: 'duedate', sortable: false },
      { text: 'Cover.ListCover.AMOUNT_COLUMN_NAME', align: 'left', value: 'amount', sortable: false },
      { text: 'Cover.ListCover.INVOICE_NUMBER_COLUMN_NAME', align: 'left', value: 'number', sortable: false },
      { text: 'Cover.ListCover.COVER_DATE_COLUMN_NAME', align: 'left', value: 'coverdate', sortable: false },
      { text: 'Cover.ListCover.COVER_PRICE_COLUMN_NAME', align: 'left', value: 'coverprice', sortable: false },
      { text: 'Cover.ListCover.ACTION_COLUMN_NAME', align: 'left', value: 'action', sortable: false }
    ],
    quotedHeaders: [
      { text: '', align: 'left', value: 'first', sortable: false },
      { text: 'Cover.ListCover.SELLER_COLUMN_NAME', align: 'left', value: 'seller', sortable: false },
      { text: 'Cover.ListCover.BUYER_COLUMN_NAME', align: 'left', value: 'buyer', sortable: false },
      { text: 'Cover.ListCover.ISSUE_DATE_COLUMN_NAME', align: 'left', value: 'issuedate', sortable: false },
      { text: 'Cover.ListCover.DUE_DATE_COLUMN_NAME', align: 'left', value: 'duedate', sortable: false },
      { text: 'Cover.ListCover.AMOUNT_COLUMN_NAME', align: 'left', value: 'amount', sortable: false },
      { text: 'Cover.ListCover.STATUS_COLUMN_NAME', align: 'left', value: 'status', sortable: false },
      { text: 'Cover.ListCover.ACTION_COLUMN_NAME', align: 'left', value: 'action', sortable: false, isVisibleOnlyWhenUserCanUpdateCovers: true }
    ],
    settledHeaders: [
      { text: '', align: 'left', value: 'first', sortable: false },
      { text: 'Cover.ListCover.SELLER_COLUMN_NAME', align: 'left', value: 'seller', sortable: false },
      { text: 'Cover.ListCover.BUYER_COLUMN_NAME', align: 'left', value: 'buyer', sortable: false },
      { text: 'Cover.ListCover.ISSUE_DATE_COLUMN_NAME', align: 'left', value: 'issuedate', sortable: false },
      { text: 'Cover.ListCover.DUE_DATE_COLUMN_NAME', align: 'left', value: 'duedate', sortable: false },
      { text: 'Cover.ListCover.SETTLED_AT_COLUMN_NAME', align: 'left', value: 'settledat', sortable: false },
      { text: 'Cover.ListCover.AMOUNT_COLUMN_NAME', align: 'left', value: 'amount', sortable: false },
      { text: 'Cover.ListCover.STATUS_COLUMN_NAME', align: 'left', value: 'status', sortable: false }
    ],
    timebarredHeaders: [
      { text: '', align: 'left', value: 'first', sortable: false },
      { text: 'Cover.ListCover.SELLER_COLUMN_NAME', align: 'left', value: 'seller', sortable: false },
      { text: 'Cover.ListCover.BUYER_COLUMN_NAME', align: 'left', value: 'buyer', sortable: false },
      { text: 'Cover.ListCover.ISSUE_DATE_COLUMN_NAME', align: 'left', value: 'issuedate', sortable: false },
      { text: 'Cover.ListCover.DUE_DATE_COLUMN_NAME', align: 'left', value: 'duedate', sortable: false },
      { text: 'Cover.ListCover.AMOUNT_COLUMN_NAME', align: 'left', value: 'amount', sortable: false },
      { text: 'Cover.ListCover.STATUS_COLUMN_NAME', align: 'left', value: 'status', sortable: false }
    ],
    submittedClaim: {
      buyer: {
        firstName: '',
        lastName: '',
        email: '',
        mobilePhone: '',
        officePhone: ''
      },
      seller: {
        firstName: '',
        lastName: '',
        email: '',
        mobilePhone: '',
        officePhone: ''
      },
      invoicedisputed: '',
      buyerinsolvency: '',
      invoicedisputedValue: '',
      buyerinsolvencyValue: '',
      comment: '',
      clientRefNumber: '',
      collectedAmount: '',
      amountWithoutVAT: '',
      fundedAmount: '',
      deliveryDate: '',
      documents: []
    },
    coverStatus: [
      { name: 'Pending', label: 'Quoted' },
      { name: 'Activated', label: 'Activated' },
      { name: 'Rejected', label: 'Refused' },
      { name: 'Cancelled', label: 'Cancelled' },
      { name: 'Settled', label: 'Settled' },
      { name: 'Claimed', label: 'Claimed' },
      { name: 'Expired', label: 'Expired' },
      { name: 'TimeBarred', label: 'Time-Barred' },
      { name: 'Assessing', label: 'Assessing' }
    ],
    claimStatus: [
      { name: 'Pending', label: 'Pending' },
      { name: 'Assessing', label: 'Assessing' },
      { name: 'Waiting', label: 'Waiting' },
      { name: 'Paid', label: 'Paid' },
      { name: 'CollectionOnly', label: 'Collection Only' },
      { name: 'Closed', label: 'Closed' },
      { name: 'OnError', label: 'Pending' }
    ],
    documentType: {
      invoice: 'Invoice',
      proofOfDelivery: 'ProofOfDelivery',
      purchaseOrder: 'PurchaseOrder',
      powerOfAttorney: 'PowerOfAttorney'
    },
    createNewCoverDialog: false
  },
  getters: {

  },
  mutations: {
    setCoverDetails (state, coverdetails) {
      state.cover = coverdetails
    },
    setExtendedMode (state, extendedMode) {
      state.extendedMode = extendedMode
    },
    setSubmittedClaim (state, submittedClaim) {
      state.submittedClaim = submittedClaim
    },
    setCreateNewCoverDialog (state, value) {
      state.createNewCoverDialog = value
    }
  },
  actions: {
    setCoverDetails (context, coverdetails) {
      context.commit('setCoverDetails', coverdetails)
    },
    setExtendedMode (context, extendedMode) {
      context.commit('setExtendedMode', extendedMode)
    },
    setSubmittedClaim (context, submittedClaim) {
      context.commit('setSubmittedClaim', submittedClaim)
    },
    setCreateNewCoverDialog (context, value) {
      context.commit('setCreateNewCoverDialog', value)
    }
  }
}
